import { render, staticRenderFns } from "./saldos_proveedores.vue?vue&type=template&id=3861d5ce&"
import script from "./saldos_proveedores.vue?vue&type=script&lang=js&"
export * from "./saldos_proveedores.vue?vue&type=script&lang=js&"
import style0 from "./saldos_proveedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports